import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import FrontendLayout from "./layouts/FrontendLayout.js";
import AdminLayout from "./layouts/AdminLayout.js";
import AuthLayout from "./layouts/AuthLayout.js";

import Home from "./pages/front/Home.js";
import Preview from "./pages/front/HomePreview.js";
import Upload from "./pages/front/Upload.js";
import FullPreview from "./pages/front/FullPreview.js";
import AdminDashboard from "./pages/admin/AdminDashboard.js";
import Completed from "./pages/front/Completed.js";
import AdminLogin from "./pages/auth/AdminLogin.js";
import UserLogin from "./pages/auth/UserLogin.js";
import {
  ProtectedRoute,
  AdminProtectedRoute,
} from "./components/ProtectedRoute.js";

import PreventLoginPage from "./components/PreventLoginPage.js";
import TotalStudents from "./pages/admin/TotalStudents.js";
import FormSubmitted from "./pages/admin/FormSubmitted.js";
import VerifiedStudent from "./pages/admin/VerifiedStudent.js";
import ApprovedStudent from "./pages/admin/ApprovedStudent.js";
import DiscrepencyStudent from "./pages/admin/DiscrepencyStudents.js";
import RejectedStudent from "./pages/admin/RejectedStudents.js";
import FreshViewData from "./pages/admin/FreshViewData.js";
import ApprovedViewData from "./pages/admin/ApprovedViewData.js";
import Admin from "./pages/admin/Admin.js";

const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/",
        element: (
          <PreventLoginPage>
            <UserLogin />
          </PreventLoginPage>
        ),
      },
    ],
  },

  {
    element: (
      <ProtectedRoute>
        <AuthLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/personal", element: <Home /> },
      { path: "/preview", element: <Preview /> },
      { path: "/upload", element: <Upload /> },
      { path: "/fullPreview", element: <FullPreview /> },
      { path: "/completed", element: <Completed /> },
    ],
  },

  {
    element: <AuthLayout />,
    children: [
      {
        path: "/admin",
        element: (
          <PreventLoginPage>
            <AdminLogin />
          </PreventLoginPage>
        ),
      },
    ],
  },

  {
    path: "/admin",
    element: (
      <AdminProtectedRoute>
        <AdminLayout />
      </AdminProtectedRoute>
    ),
    children: [
      { path: "dashboard", element: <AdminDashboard /> },
      { path: "adminPage", element: <Admin /> },
      { path: "totalStudents", element: <TotalStudents /> },
      { path: "formSubmitted", element: <FormSubmitted /> },
      { path: "verifiedStudents", element: <VerifiedStudent /> },
      { path: "approvedStudents", element: <ApprovedStudent /> },
      { path: "discrepencyStudents", element: <DiscrepencyStudent /> },
      { path: "rejectedStudents", element: <RejectedStudent /> },
      {
        path: "formSubmitted/freshView/:sol_roll_no",
        element: <FreshViewData />,
      },
      {
        path: "verifiedStudents/verifiedView/:sol_roll_no",
        element: <FreshViewData />,
      },
      {
        path: "approvedStudents/approvedView/:sol_roll_no",
        element: <FreshViewData />
      },
      {
        path:"discrepencyStudents/discrepancyView/:sol_roll_no",
        element: <FreshViewData/>
      },
      {
        path: "rejectedStudents/rejectedView/:sol_roll_no",
        element: <FreshViewData/>
      }
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
